import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import { StyleSheet } from 'react-native';
import { ButtonProps } from 'react-native-elements/dist/buttons/Button';
import { palette } from '../../theme';
import { Button } from '../Button/Button';
import { Text } from '../Text/Text';

import { LocalImage } from '$tablet-app/src/app/images/types';
import Dropzone from 'react-dropzone';

export interface SelectImageButtonProps extends Partial<ButtonProps> {
  onSelect: (image: LocalImage) => void;
}

const SelectImageButton: FC<SelectImageButtonProps> = (props) => {
  let dropzoneRef: any;

  const chooseProfileImage = (acceptedFiles: any) => {
    const uri = URL.createObjectURL(acceptedFiles[0]);
    const file = { ...acceptedFiles[0], path: uri };
    props.onSelect(file);
  };

  return (
    <>
      <Dropzone
        ref={(node) => {
          dropzoneRef = node;
        }}
        accept={{
          'image/*': [],
        }}
        onDrop={(acceptedFiles) => chooseProfileImage(acceptedFiles)}
      >
        {({ getRootProps, getInputProps }) => (
          <section>
            <div {...getRootProps()}>
              <input {...getInputProps()} />
            </div>
          </section>
        )}
      </Dropzone>
      <Button
        style={styles.settingsButton}
        text="Upload photo"
        preset="primary"
        {...props}
        onPress={(e) => {
          e.preventDefault(); // --> without this onClick fires 3 times
          dropzoneRef.open();
        }}
      >
        <FontAwesomeIcon size={30} icon="camera" style={styles.icon} />
        <Text style={styles.uploadButtonText}>Upload photo</Text>
      </Button>
    </>
  );
};

const styles = StyleSheet.create({
  settingsButton: {
    justifyContent: 'flex-start',
  },
  uploadButtonText: {
    color: palette.white,
    fontSize: 18,
    fontWeight: 'bold',
    padding: 10,
  },
  icon: { color: palette.white },
});

export default SelectImageButton;
